import http from '../_http_v2';

const forgerydetect = {
  //default
  list: (m) => { return http.post(`console/wsfinder/forgerydetect/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/forgerydetect/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/forgerydetect`, m); },
  update: (m) => { return http.put(`console/wsfinder/forgerydetect`, m)},
  delete: (m) => { return http.delete(`console/wsfinder/forgerydetect/${m.id}`); },
}

export default forgerydetect

export { forgerydetect }